<template>
	<div>
		<h1>Layer Editor</h1>
		<p>{{ message }}</p>
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: [String],
			default: 'Default message'
		}
	},
	data() {
		return {
			count: 0
		}
	},
	mounted() {
		console.log('Layer Editor All set')
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/admin/assets/js/app/layers/LayerEditor.vue